import React, { useEffect, useState } from 'react'
import { Container, SecondRowContainer } from './styled'
import { useParams } from 'react-router-dom'
import BookingHeader from '../bookingHeader/view'
import { getBooking } from 'api'
import { Grid } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import dayjs from 'dayjs';

const BookingSingle = () => {

  const params = useParams()
  const { slug } = params
  const [booking, setBooking] = useState(null)

  const [value, setValue] = useState("0");
  const [selectedDate] = useState(dayjs());
  const [,setHighlightedDays] = useState([1, 5, 7, 10, 20, 27])
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = ( newValue) => {
    setValue(newValue);
  };

  const handleMonthChange = () => {
    setIsLoading(true);
    setHighlightedDays([]);
  };

  function getBookingInfo() {
    getBooking(slug).then(r => {
      setBooking(r)
    })
  }

  useEffect(() => {
    getBookingInfo(true)
  }, [])


  return (
    <Container>
      <BookingHeader title={booking?.venue?.name} subtitle={booking?.venue?.single_address} avatar={booking?.venue?.image} background={booking?.venue?.background} />
      <Grid container>
        <Grid item xs={12} md={9}>
          <TabContext value={value}>
            <SecondRowContainer>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
              >
                <Tab label="Overview" value="0" />
                <Tab label="Workspace" value="1" />
                <Tab label="Amenities" value="2" />
                <Tab label="Events" value="3" />
                <Tab label="Community" value="4" />
                <Tab label="Gallery" value="5" />
              </Tabs>
              <div>
                {/* Tab content sections */}
                <TabPanel value="0" index={0}>
                  {booking?.name}
                  <br />
                  {booking?.description}

                </TabPanel>
                <TabPanel value="1" index={1}>
                  {/* Content for workspace section */}
                  Workspace section
                </TabPanel>
                <TabPanel value="2" index={2}>
                  {/* Content for amenities section */}

                </TabPanel>
                <TabPanel value="3" index={3}>
                  {/* Content for Events section */}

                </TabPanel>
                <TabPanel value="4" index={4}>
                  {/* Content for Bookings section */}
                  communites section content
                </TabPanel>
                <TabPanel value="5" index={5}>
                  {/* Content for Partners section */}
                  Gallery
                </TabPanel>
              </div>
            </SecondRowContainer>
          </TabContext>
        </Grid>
        <Grid item xs={12} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
              value={selectedDate}
              loading={isLoading}
              onMonthChange={handleMonthChange}
              renderLoading={() => <DayCalendarSkeleton />}
            />
          </LocalizationProvider>
        </Grid>

      </Grid>

    </Container>
  )
}

BookingSingle.propTypes = {}

export default BookingSingle
